import { request, toNumber, __, getTutorialSteps } from '../functions';
import _ from 'lodash';
import {
    FETCH_ACCOUNTING,
    FETCH_ACCOUNTING_DATA,
    CHANGE_ACCOUNTING_AUTO_FIELD,
    CHANGE_ACCOUNTING_SETTINGS,
    CREATE_ACCOUNTING,
    DELETE_ACCOUNTING,
} from './types';

/**
 * Nacitanie fakturacneho systemu.
 *
 * @param {Screen} screen
 */
export const fetchAccounting = screen => {
    let url = '/user-eshops/accounting';

    if (window.location.pathname === '/seller-accounting') {
        url = '/mtokna/accounting';
    }

    return dispatch => request(url).then(({ data }) => {
        const { user } = data.sync;
        const { setUser } = screen.props;

        // Nasetujeme usera
        setUser(user);

        dispatch({ type: FETCH_ACCOUNTING, payload: data.data });
    });
};

/**
 * Nacitanie dat fakturacneho systemu.
 *
 * @param {Screen} screen
 */
export const fetchAccountingData = screen => {
    let params = {};

    if (screen.getTutorialStep() === 3) {
        // Sme na tretom kroku, nastavime stvrti
        params = { tutorial_step: 4 };
    }

    return dispatch => request('/user-eshops/accountingData', params).then(response => {
        const { status, data } = response.data;

        screen.setState({ loadingData: false });

        if (status === 'error') {
            // Nepodarilo sa nacitat data
            screen.showSnackbar('error', __('Nepodarilo sa načítať dáta z ekonomického systému'));
            return;
        }

        screen.showSnackbar('success', __('Údaje z ekonomického systému boli načítané'));

        dispatch({ type: FETCH_ACCOUNTING_DATA, payload: data });

        if (_.has(params, 'tutorial_step') && window.location.pathname !== '/seller-accounting') {
            // Sme na tretom kroku presmerujeme
            screen.redirect(getTutorialSteps()[4].redirect);
        }
    });
};

/**
 * Zmenime auto field fakturacneho systemu.
 *
 * @param {Screen} screen
 * @param {string} field
 * @param {boolean} value
 */
export const changeAccountingAutoField = (screen, field, value) => {
    return dispatch => request(`/user-eshops/setAccountingAuto/${field}/${toNumber(value)}`).then(({ data }) => {
        screen.showSnackbar('success', value ? __('Zapnuté') : __('Vypnuté'));

        dispatch({ type: CHANGE_ACCOUNTING_AUTO_FIELD, payload: { field, value } });
    });
};

/**
 * Zmenime nastavenia fakturacneho systemu.
 *
 * @param {Screen} screen
 * @param {Object} settings
 */
export const changeAccountingSettings = (screen, settings) => {
    return dispatch => request('/user-eshops/changeAccountingSettings', { settings }, 'POST').then(response => {
        const { status } = response.data;

        screen.setState({ loading: false });

        if (status === 'error') {
            // Nepodarilo sa zmenit nastavenia
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť nastavenia'));
            return;
        }

        screen.showSnackbar('success', __('Nastavenia boli zmenené'));

        dispatch({ type: CHANGE_ACCOUNTING_SETTINGS, payload: settings });
    });
};

/**
 * Vytvorenie prepojenia na ekonomicky system.
 *
 * @param {number} id
 */
export const createAccounting = id => ({ type: CREATE_ACCOUNTING, payload: id });

/**
 * Zmazanie prepojenia na ekonomicky system.
 */
export const deleteAccounting = () => ({ type: DELETE_ACCOUNTING });
